import { useState } from "react";
import styled from "styled-components";
import MayoLogo from "../common/MayoLogo";
import MayoVideoHeader from "../common/MayoVideoHeader";

import videoThumbnail from "/thumbnail1.jpg";
import { useLocation, useParams } from "react-router-dom";
import MayoVisitInfo from "../common/MayoVisitInfo";
import ListBox from "../common/ListBox";

import checkIcon from "../../../../assets/Mayo/checkmarrk_icon.svg";
import MedInstruction from "../common/MedInstruction";
import doctorIcon from "../../../../assets/Mayo/Doctor.svg";
import testsIcon from "../../../../assets/Mayo/Tests.svg";
import MayoRelaxation from "../common/MayoRelaxation";
import MayoHelp from "../common/MayoHelp";
import MayoContactSection from "../common/ContactSection";
import MayoFooter from "../common/MayoFooter";
import IodineWarning from "../common/IodineWarning";
import AppointmentsPopUp from "./AppointmentsPopUp";
import bgImg from "../../../../assets/Mayo/bg_1_for_videe_pages.svg"
import MayoGetAround from "../common/MayoGetAround";
import { useEffect } from "react";
import { AVATAR_OPTIONS } from "./MayoChooseAvatar";
import { usePatientFacing } from "../../../../flow/patientFacing/hooks/usePatientFacing";
import { EVENT_LOCATIONS } from "../consts";

const PRE_VISIT_TESTS = [
  {margin: "0 0px 10px 0", iconStyle: {height: 11, width: 15, marginRight: 15, marginTop: 6}, icon: checkIcon, text: "Echocardiogram"},
  {margin: "0 0px 10px 0", iconStyle: {height: 11, width: 15, marginRight: 15, marginTop: 6}, icon: checkIcon, text: "Chest X-ray"},
  {margin: "0 16px 10px 0", iconStyle: {height: 11, width: 15, marginRight: 15, marginTop: 6}, icon: checkIcon, text: "Electrocardiogram (ECG)"},
  {margin: "0 16px 10px 0", iconStyle: {height: 11, width: 15, marginRight: 15, marginTop: 6}, icon: checkIcon, text: "Blood tests"},
  {margin: "0 16px 10px 0", iconStyle: {height: 11, width: 15, marginRight: 15, marginTop: 6}, icon: checkIcon, text: "CTA exam"}
]

const getDateString = (date) => {
  return new Date(date).toLocaleDateString("en-US", {
    weekday: "short",
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const TextComponent = ({ text }) => {
  const TextStyled = styled.p`
    color: #1A1A1A;
    font-size: 19px;
    margin: 0;
  `
  
  return <TextStyled>{text}</TextStyled>;
}


export default function MayoVideoPage1({}) {
  const { getEventDataLocal, fetchEvent } = usePatientFacing();
  let event = getEventDataLocal();

  const [ avatarImage, setAvatarImage] = useState("");

  const { hasCTA, clinicVisit } = event?.Case?.CardiologyCase || {};
  const location = EVENT_LOCATIONS[event?.facingType]; // TODO - add data

  const [showAppointments, setShowAppointments] = useState(false);

  const closePopUp = () => {
    setShowAppointments(false);
  }

  const loadEventData = async () => {
    if(!event) return;

    if(!event?.age) {
      event = await fetchEvent(event.id, true);
    }
  }

  const loadAvatarImage = () => {
    if(!event?.Case?.Avatar) return;

    const { age, gender, ethnicity } = event.Case.Avatar;
    const avatar = AVATAR_OPTIONS.filter(avatar => 
      avatar.ageAvatarVal === age &&
      avatar.sex.toLowerCase() === gender &&
      avatar.ethnicity === ethnicity
    )
    setAvatarImage(avatar?.[0]?.image || "avatar image not found");
  }

  useEffect(() => {
    loadEventData();
    loadAvatarImage();
  }, []);

  return (
    event &&
    <Container>
      { showAppointments &&
        <AppointmentsPopUp onCancle={closePopUp} />
      }

      <MayoLogo />
      <MayoVideoHeader 
        postAnalyticType={"watchedVideo"}
        title={"Watch the video to learn more about your expected journey"}
        videoThumbnail={videoThumbnail}
      />
      <HL />
      <Avatar 
        src={avatarImage}
      />

      <MayoVisitInfo 
        procedureText={"You were scheduled for a clinic visit for "}
        procedureDate={getDateString(clinicVisit)}
        address1={location.address1}
        address2={location.address2}
      />

      <ShowAllAppointmentsText
        onClick={() => setShowAppointments(true)}
      >
        Show me all my appointments
      </ShowAllAppointmentsText>

      
      <ListBox
        style={{paddingBottom: 25, marginBottom: 39}}
        headerMargin="0 0 24px 0"
        title={"Tests you may have prior to your clinic visit include:"}
        TitleIcon={<TestsIcon src={testsIcon}/>}
        list={hasCTA ? PRE_VISIT_TESTS : PRE_VISIT_TESTS.slice(0, -1)}
        Component={MedInstruction}
      />

      { hasCTA &&
        <IodineWarning />
      }

      <ListBox
        style={{paddingBottom: 25, marginBottom: 40, marginTop: 34}}
        headerMargin="0 0 24px 0"
        title={"TAVR Prep: mouth matters"}
        TitleIcon={<DoctorIcon src={doctorIcon} width={70}/>}
        list={[{text: "Bacteria in your mouth can affect your heart and may increase the risk of infection on your new heart valve. Before your TAVR procedure, your dentist will need to sign a form confirming you are cleared for the procedure."}]}
        Component={TextComponent}
      />

      <MayoRelaxation />
      <HL/>
      <MayoGetAround style={{marginTop: 36, marginBottom: 50}}/>
      <HL/>
      <MayoHelp />
      <HL style={{marginBlock: 36}}/>
      <MayoContactSection subtitle="TAVR Clinic Scheduler" />
      <HL style={{marginTop: 36}}/>
      <MayoFooter />

    </Container>
  );
}

const Container = styled.div`
  font-family: Abraham;
  min-height: 100vh;
  background-image: url("${bgImg}");
  background-repeat: repeat;
  background-size: cover;
  background-position: center;
`

const HL = styled.div`
  background-color: #CCD9FB;
  height: 1px;
  margin-inline: 26px;
`

const Avatar = styled.img`
  display: block;
  border-radius: 50%;
  width: 100px;
  height: 100px;

  margin-top: 24px;
  margin-left: 23px;
`

const ShowAllAppointmentsText = styled.p`
  margin: 0;
  margin-top: 18px;
  margin-left: 26px;
  margin-bottom: 36px;;

  color: #81A0F6;
  font-size: 19px;
  font-weight: 500;
  text-decoration: underline;
`

const TestsIcon = styled.img`
  width: 70px;
  margin-left: 16px;
`

const DoctorIcon = styled.img`
  width: 70px;
  height: 70px;
  margin-left: 61px;
`
